import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { uploadMasterFile } from 'api/auth.api';
import Swal from 'sweetalert2';

const getErrorMessage = (error, fallback) => {
  const msg = error?.response?.data?.message;
  if (typeof msg === 'string') return msg;
  if (typeof msg === 'object' && msg?.message) return msg.message;
  return fallback;
};

export const useUploadMasterFile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (file) => {
      const formData = new FormData();
      formData.append('file', file);
      return uploadMasterFile(formData);
    },

    onSuccess: (res) => {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'success',
        title: res?.data?.message || 'Upload successful',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
      queryClient.invalidateQueries(['uploadedMasterList']);
    },

    onError: (error) => {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        title: getErrorMessage(error, 'Failed to upload Excel file'),
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
      });
    },
  });
};
